export const STRENGTH_EQUIPMENT = [
    "Barra",
    "Halteres",
    "Máquina",
    "Cabo",
    "Kettlebell",
    "Elástico",
    "Peso Corporal",
    "Smith",
    "TRX",
    "Anilha",
];

export const MUSCLE_GROUPS = [
    "Peito",
    "Costas",
    "Ombros",
    "Deltóide",
    "Trapézio",
    "Bíceps",
    "Tríceps",
    "Antebraço",
    "Quadríceps",
    "Posterior",
    "Glúteos",
    "Adutor",
    "Abdutor",
    "Panturrilha",
    "Abdômen",
    "Core",
    "Lombar",
    "Serrátil",
    "Full Body",
];

export const STRENGTH_EXERCISE_METHODS = [
    { value: "straight", label: "Série normal", desc: "Séries independentes com a mesma lógica de carga e repetições." },
    { value: "dropset", label: "Drop set", desc: "Reduz a carga após a série principal e continua sem descanso longo." },
    { value: "pyramid_asc", label: "Pirâmide crescente", desc: "Aumenta a carga e reduz repetições ao longo das séries." },
    { value: "pyramid_desc", label: "Pirâmide decrescente", desc: "Reduz a carga e aumenta repetições ao longo das séries." },
    { value: "restpause", label: "Rest-pause", desc: "Pausa curta após a falha técnica e completa repetições adicionais." },
];

export const DEFAULT_STRENGTH_SET = {
    type: "strength_exercise",
    exercise: "",
    exerciseId: "",
    strengthMethod: "straight",
    sets: 3,
    reps: "12",
    load: "",
    rest: "60s",
    tempo: "",
    muscleGroup: "",
    primaryMuscles: [],
    secondaryMuscles: [],
    equipment: "",
    description: "",
    instructions: "",
};
